window.onload = function() {
	const paragraphs = document.querySelectorAll('.page-legale p')
	const page = document.querySelector('.page-legale')

	formatUrl(paragraphs)

	if(!page.classList.contains('CGV')) return

	const sommaireRaw = paragraphs[1]
	const sommaireRawContent = sommaireRaw.innerHTML.split('<br>').map(title => {
		return `<span data-anchor=${title.replaceAll(' ','-')} class="pointer">${title}</span>`
	}).join('<br>')

	const titles = [...paragraphs].filter(paragraph => paragraph.classList.contains('p1'))

	titles.forEach(title => {
		const content = title.querySelector('b')

		if(!content) return

		const contentText = content.innerText
		title.setAttribute('id', contentText.replaceAll(' ','-'))
	})

	sommaireRaw.innerHTML = sommaireRawContent

	const sommaire = sommaireRaw.querySelectorAll('span')

	sommaire.forEach(title => {
		const handleClick = e => {
			const id = e.target.dataset.anchor
			const div = document.getElementById(id)

			if(!div) return

			const top = div.getBoundingClientRect().top - 110 + window.pageYOffset

			scrollTo({top: top,  behavior: 'smooth'} )
		}

		title.addEventListener('click', handleClick)

		window.onunload = function () {
			title.removeEventListener('click', handleClick)
		}
	})
}

